/* eslint-disable unicorn/filename-case */
/* eslint-enable unicorn/filename-case */
import { ActorInitQueryBase } from './ActorInitQueryBase';

export class ActorInitQuery extends ActorInitQueryBase {}
